<template>
    <div class="wrapper">
        <Con1></Con1>
        <Con2></Con2>
        <Con3></Con3>
        <Con4></Con4>
        <Con5></Con5>
        <Con6></Con6>
        <Con7></Con7>
        <Con8></Con8>
        <Con9></Con9>
        <Con10></Con10>
    </div>
</template>
<script>
import Con1 from "@/components/Malangtalk/con1.vue"
import Con2 from "@/components/Malangtalk/con2.vue"
import Con3 from "@/components/Malangtalk/con3.vue"
import Con4 from "@/components/Malangtalk/con4.vue"
import Con5 from "@/components/Malangtalk/con5.vue"
import Con6 from "@/components/Malangtalk/con6.vue"
import Con7 from "@/components/Malangtalk/con7.vue"
import Con8 from "@/components/Malangtalk/con8.vue"
import Con9 from "@/components/Malangtalk/con9.vue"
import Con10 from "@/components/Malangtalk/con10.vue"

export default {
    components: { Con1, Con2, Con3, Con4, Con5, Con6, Con7, Con8, Con9, Con10 },
    // head: {
    //   title: {
    //     inner: "마이 랭귀지 튜터",
    //     separator: '-',
    //     complement: 'malang talk (말랑톡)'
    //   },
    // Meta tags
    // meta: [
    //   {name: "description", content: "진짜 문제는 회화! 무조건 뱉어야 느는 영어, 원어민 튜터와 맘껏 톡하자! 철저한 검증으로 엄선된 교육 전문 원어민 튜터와 만족할 때까지 진짜 대화를 즐기세요"},
    //   // OpenGraph data (Most widely used)
    //   {property: 'og:title', content: '마이 랭귀지 튜터, malang talk (말랑톡)'},
    //   {property: 'og:site_name', content: '말랑톡'},
    //   // The list of types is available here: http://ogp.me/#types
    //   {property: 'og:type', content: 'website'},
    //   // Should the the same as your canonical link, see below.
    //   {property: 'og:url', content: 'https://malangtalk.com'},
    //   {property: 'og:image', content: 'https://kr.object.ncloudstorage.com/aitutor-plus/logo/logo_default.png'},
    //   // Often the same as your meta description, but not always.
    //   {property: 'og:description', content: '영어, 난 쫄지 않아!" 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요.나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!'},

    //   // Google / Schema.org markup:
    //   {itemprop: 'name', content: '마이 랭귀지 튜터, malang talk (말랑톡)'},
    //   {itemprop: 'description', content: '영어, 난 쫄지 않아!" 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요.나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!'},
    //   {itemprop: 'image', content: 'https://kr.object.ncloudstorage.com/aitutor-plus/logo/logo_default.png'}
    // ],
    // },
    // metaInfo: {
    //   title: "마이 랭귀지 튜터, malang talk (말랑톡)",
    //   meta: [
    //     {name: "description", content: "진짜 문제는 회화! 무조건 뱉어야 느는 영어, 원어민 튜터와 맘껏 톡하자! 철저한 검증으로 엄선된 교육 전문 원어민 튜터와 만족할 때까지 진짜 대화를 즐기세요"},
    //     // OpenGraph data (Most widely used)
    //     {property: 'og:title', content: '마이 랭귀지 튜터, malang talk (말랑톡)'},
    //     {property: 'og:site_name', content: '말랑톡'},
    //     // The list of types is available here: http://ogp.me/#types
    //     {property: 'og:type', content: 'website'},
    //     // Should the the same as your canonical link, see below.
    //     {property: 'og:url', content: 'https://malangtalk.com/index'},
    //     {property: 'og:image', content: 'https://kr.object.ncloudstorage.com/aitutor-plus/logo/logo_default.png'},
    //     // Often the same as your meta description, but not always.
    //     {property: 'og:description', content: '영어, 난 쫄지 않아!" 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요.나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!'},

    //     // Google / Schema.org markup:
    //     {itemprop: 'name', content: '마이 랭귀지 튜터, malang talk (말랑톡)'},
    //     {itemprop: 'description', content: '영어, 난 쫄지 않아!" 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요.나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!'},
    //     {itemprop: 'image', content: 'https://kr.object.ncloudstorage.com/aitutor-plus/logo/logo_default.png'}
    //   ],
    // },
}
</script>
<style lang="scss" scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css");

.wrapper {
    font-family: "Pretendard", "Malgun Gothic", "맑은고딕", sans-serif;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-use-select: none;
    user-select: none;
}
</style>
